// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"5ca31473","396":"915c1b88","453":"1dc7c5f5","498":"7f900853","616":"1951cbb7","828":"84becf43"}[chunkId] + ".chunk.js";
};